import React, {memo} from "react"
import { BezierEdge } from "@xyflow/react"
import { SECTION_COLOR } from "../FlowPage"

export default memo(function PseEdge(props) {
    const { data: { highlighted }, ...otherProps } = props
    return (
        <BezierEdge {...otherProps}
            style={{
                stroke: highlighted ? SECTION_COLOR : "black",
                strokeWidth: highlighted ? 3 : 1,
                transition: "stroke 0.2s ease, stroke-width 0.2s ease",
            }}
        />
    )
})